import { Injectable, Injector } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';

import {AppConfigService}  from '../app-config/app-config.service';
import { AuthService } from './auth.service';
import {Observable, ReplaySubject} from 'rxjs';


@Injectable({
  providedIn: "root"
})
export class TokenInterceptor implements HttpInterceptor {
    private auth: AuthService;

    constructor(private inj: Injector, private _appConfigService: AppConfigService, private router: Router) {


    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const requestSubject = new ReplaySubject<HttpEvent<any>>(1);

        this.auth = this.inj.get(AuthService)

        // Add Authorization header to all requests beside Authentication
        if (request.url !== this._appConfigService.getAuthURL() + "/OAuth/Token") {
            request = request.clone({
                setHeaders: {
                    Authorization: "Bearer " + this.auth.getCachedToken().accessToken
                }
            });


            // Intercept the message response for all requests beside Authentication
            next.handle(request).subscribe(
                (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        // do stuff with response if you want
                        requestSubject.next(event);
                        requestSubject.complete();
                    }
                },
                (err: any) => {
                    // If unauthorization error
                    if ((err instanceof HttpErrorResponse) && (err.status === 401)) {
                        // If already logged in
                        if (this.auth.getIsAuthenticated()) {
                            // Refresh access token
                            this.auth.refreshAccessToken().subscribe(
                                // Refreshing the token failed
                                data => {
                                    // Set the refreshed access token in the header
                                    request = request.clone({
                                        setHeaders: {
                                            Authorization: "Bearer " + this.auth.getCachedToken().accessToken
                                        }
                                    });

                                    // Resend the original request
                                    next.handle(request).subscribe(
                                        (event: HttpEvent<any>) => {
                                            if (event instanceof HttpResponse) {
                                                // do stuff with response if you want
                                                requestSubject.next(event);
                                                requestSubject.complete();
                                            }
                                        },
                                        // Refreshing the token failed
                                        (err: any) => {
                                            if (err instanceof HttpErrorResponse) {
                                                // If we get unauthorize after refreshing the token log out
                                                if (err.status === 401) {
                                                    // Logout from the application
                                                    this.auth.logout();
                                                    this.router.navigate(['/login']);
                                                }
                                                // Another error raise
                                                else {
                                                    requestSubject.error(err);
                                                    requestSubject.complete();
                                                }
                                            }
                                            // Another error raise
                                            else {
                                                requestSubject.error(err);
                                                requestSubject.complete();
                                            }
                                        });
                                },
                                // Another error raise
                                err => {
                                    requestSubject.error(err);
                                    requestSubject.complete();
                                });
                        }
                        else {
                            // redirect to the login route
                            this.auth.logout();
                            this.router.navigate(['/login']);
                            requestSubject.error(err);
                            requestSubject.complete();
                        }
                    }
                    else {
                        requestSubject.error(err);
                        requestSubject.complete();
                    }
                }
            );

            return requestSubject.asObservable();
        }
        // Authentication request (to auth server) do not intervene
        else {
            // Intercept the message response
            return next.handle(request)
        }
    }
}
